export default {"src":"/_next/static/media/flag-es.589ab9af.svg","height":500,"width":750,"blurWidth":0,"blurHeight":0};